import { NotificationFamilyEnum, NotificationSortEnum } from '@/types/data/data.types';
import { DateTimeRange } from '@/types/dateTime.types';
import { ClassificationEnum } from '@/types/sensor/classification.types';
import { ReliabilityEnum } from '@/types/sensor/identification.types';
import { ConnectorStatusEnum, HealthStatusEnum } from '@/types/sensor/sensors';

export type WorstSensorStatusOption = HealthStatusEnum.DEGRADED | HealthStatusEnum.KO | ConnectorStatusEnum.UNREACHABLE;

export type NotificationSearchFilters = {
  category: NotificationFamilyEnum;
  identifiers: string[];
  displayIds: string[];
  range: DateTimeRange;
  sort: NotificationSortEnum | null;
  worstClassification: Set<Exclude<ClassificationEnum, ClassificationEnum.UNCLASSIFIED>>;
  useAltitude: boolean;
  minimumMaxHeight: number;
  duration: number;
  trackSensorUniqueKeys: string[];
  zoneIds: number[];
  worstSensorStatus: Set<WorstSensorStatusOption>;
  platforms: string[];
  maximumMaxHeight?: number;
  reliability?: ReliabilityEnum;
};

export enum SearchFilterOptionEnum {
  PLATFORM = 'PLATFORM',
  COLLABORATIVE_ID = 'COLLABORATIVE_ID',
  ID = 'ID',
  WORST_CLASSIFICATION = 'WORST_CLASSIFICATION',
  WORST_SENSOR_STATUS = 'WORST_SENSOR_STATUS',
  DETECTION_PERIOD = 'DETECTION_PERIOD',
  INCIDENT_PERIOD = 'INCIDENT_PERIOD',
  MAX_ALTITUDE_OR_HEIGHT = 'MAX_ALTITUDE_OR_HEIGHT',
  RELIABILITY = 'RELIABILITY',
  DETECTION_DURATION = 'DETECTION_DURATION',
  TREATMENT_DURATION = 'TREATMENT_DURATION',
  TRACK_SENSOR = 'TRACK_SENSOR',
  ZONES = 'ZONES',
}

export type SearchFilterFieldName =
  | SearchFilterOptionEnum.PLATFORM
  | SearchFilterOptionEnum.COLLABORATIVE_ID
  | SearchFilterOptionEnum.ID
  | SearchFilterOptionEnum.ZONES
  | SearchFilterOptionEnum.TRACK_SENSOR;

export const SearchFilterFieldMap = {
  [SearchFilterOptionEnum.PLATFORM]: 'platforms',
  [SearchFilterOptionEnum.COLLABORATIVE_ID]: 'displayIds',
  [SearchFilterOptionEnum.ID]: 'identifiers',
  [SearchFilterOptionEnum.ZONES]: 'zoneIds',
  [SearchFilterOptionEnum.TRACK_SENSOR]: 'trackSensorUniqueKeys',
} as const;

export type NotificationSearchBackendField = (typeof SearchFilterFieldMap)[keyof typeof SearchFilterFieldMap];
